/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Project, Project$inboundSchema } from "./project.js";

export type SetProjectLogoResult = {
  project: Project;
};

/** @internal */
export const SetProjectLogoResult$inboundSchema: z.ZodMiniType<
  SetProjectLogoResult,
  unknown
> = z.object({
  project: Project$inboundSchema,
});

export function setProjectLogoResultFromJSON(
  jsonString: string,
): SafeParseResult<SetProjectLogoResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetProjectLogoResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetProjectLogoResult' from JSON`,
  );
}
